import React from "react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import { StandardNoPaddingPageProvider } from "@src/providers/StandardNoPaddingPageProvider";
import { StandardNoPaddingRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes";

import IgErrorBoundary from "../../components/Utils/IgErrorBoundary";
import { FullPageProvider } from "../../providers/FullPageProvider";
import { LoggedInProvider } from "../../providers/LoggedInProvider";
import { StandardPageProvider } from "../../providers/StandardPageProvider";
import { PublicPageRoutes } from "../public";

import { FullPageRoutes } from "./fullPageRoutes";
import { StandardPageRoutes } from "./standardPageRoutes";

const routes: RouteObject[] = [
  {
    errorElement: <IgErrorBoundary />,
    element: <LoggedInProvider />,
    children: [
      {
        element: <StandardPageProvider />,
        children: StandardPageRoutes,
      },
      {
        element: <FullPageProvider />,
        children: FullPageRoutes,
      },
      {
        element: <StandardNoPaddingPageProvider />,
        children: StandardNoPaddingRoutes,
      },
      ...PublicPageRoutes,
    ],
  },
];
const router = createBrowserRouter(routes);

export const SubscribedRoutes = () => {
  return <RouterProvider router={router} />;
};
